export const HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS = {
	hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
	takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
	onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
	isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
	hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
	hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover',
} as const;

export const HomeTakeoverOnboardingKeys = [
	...Object.values(HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS),
] as const;
